module.exports = __webpack_public_path__ + "static/media/finance_report-ioc.a0d9a98b.png";